var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-indicator-container",style:({ 'left': _vm.xPosition - 10 + 'px'})},[_c('div',{staticClass:"chart-indicator-top-half"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"chart-indicator-bottom-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }